{
  "manager": {
    "bannersCreate": {
      "textLabel": "Text",
      "typeLabel": "Type",
      "locationLabel": "Location",
      "saveBanner": "Save Banner"
    },
    "bannersIndex": {
      "title": "Banners"
    }
  }
}
